import { createFileRoute } from '@tanstack/react-router';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Loading } from '@/components/Loading';
import { activeConfig } from '@/config';
import SubmittingAClaimPage from '@/components/pages/faq/submittingAClaim';

const ProtectedSubmittingAClaimPage = withAuthenticationRequired(
  SubmittingAClaimPage,
  {
    onRedirecting: () => <Loading />,
  }
);

export const Route = createFileRoute('/faq/documents/submittingAClaim')({
  head: () => ({
    meta: [{ title: `Submitting a Claim | ${activeConfig.branding.appName}` }],
  }),
  component: ProtectedSubmittingAClaimPage,
});
